import { Message } from 'element-ui';
import axios from '~/common/plugins/axios.js'
export const state = () => ({
  pagination:{
    listName: "本次上传",
    current: 1,
    page_size: 20,
    total: 10000
  },
  searchParams:{
  }
})

export const mutations = {
  set_pagination (state,v) {
    state.pagination = v
  },
  set_searchParams (state,v) {
    state.searchParams = v;
  }
}

export const actions = {
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
